<template>
  <div class="formTitle">
    <div class="title">
      <span></span>
      {{ name }}
      <div class="required" v-if="required">（必填）</div>
    </div>
    <div class="selected" v-if="selected">
      <div class="wrapper">
        <img class="img" :src="gameImage" />
        <div class="content">
          <span
            >{{ gameName }}&ensp;<i class="el-icon-arrow-right"></i>&ensp;</span
          >
          <span
            >{{ typeName }}&ensp;<i class="el-icon-arrow-right"></i>&ensp;</span
          >
          <span v-for="(item, index) in formTextList" :key="index"
            >{{ item }}&ensp;<i
              class="el-icon-arrow-right"
              v-if="index < Object.keys(formText).length - 1"
            ></i
            >&ensp;</span
          >
        </div>
        <div class="resBtn" @click="resBtn">重选</div>
      </div>
      <div class="tips" v-if="gameId == 23 && formTextList.includes('网易国服')">
        网易国服账号，出售其中一款游戏时，同账号绑定的其余网易游戏需一同出售。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "formTitle",
  props: {
    name: {
      type: String,
      default: ""
    },
    selected: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    formText: {
      type: Object,
      default: null
    },
    gameName: {
      type: String,
      default: ""
    },
    gameId: {
      type: Number,
      default: 0
    },
    gameImage: {
      type: String,
      default: ""
    },
    typeName: {
      type: String,
      default: ""
    },
    btnClick: {
      type: Function,
      default: null
    }
  },
  computed: {
    formTextList() {
      const list = []
      for (let formTextKey in this.formText) {
        list.push(this.formText[formTextKey]);
      }
      return list
    }
  },
  methods: {
    resBtn() {
      this.btnClick();
    },
  },
};
</script>

<style lang="less" scoped>
.formTitle {
  .title {
    position: relative;
    display: flex;
    align-items: center;
    height: 63px;
    line-height: 63px;
    font-size: 20px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 800;
    letter-spacing: -0.3px;
    color: var(--text-main, #111827);
    span {
      display: inline-block;
      margin: 0 14px 0 39px;
      width: 22px;
      height: 22px;
      border-radius: 3px;
      background: var(--bg-dark, #1A1D24);
      transform: skewX(-12deg);
    }
    &::after {
      content: "";
      position: absolute;
      left: 39px;
      bottom: 12px;
      width: 32px;
      height: 3px;
      border-radius: 2px;
      background: var(--primary, #FF5A1F);
    }
    .required {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: var(--text-muted, #9AA0AC);
    }
  }
  .selected {
    background: var(--bg-card, #FFFFFF);
    display: flex;
    flex-direction: column;
    .wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 150px;
      .img {
        margin: 0 17px 0 64px;
        width: 60px;
        height: 60px;
        border-radius: 4px;
        box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);
      }

      .content {
        span {
          font-size: 16px;
          font-family: PingFangSC-Lightr, PingFang SC;
          font-weight: 400;
          color: var(--brand-blue, #1A1D24);
          line-height: 30px;
        }

        i {
          color: var(--text-secondary, #5A5F6B);
        }
      }
      .resBtn {
        margin: 0 0 0 50px;
        width: 100px;
        height: 30px;
        background: var(--primary, #FF5A1F);
        border-radius: 3px;
        line-height: 30px;
        font-size: 16px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 300;
        color: #ffffff;
        text-align: center;
        cursor: pointer;
      }
    }
    .tips {
      margin-left: 64px;
      background: var(--warning-soft, #FFFBEB);
      border: 1px solid rgba(245, 158, 11, 0.2);
      padding: 4px 20px;
      margin-bottom: 20px;
      width: max-content;
      color: var(--text-secondary, #5A5F6B);
      font-size: 16px;
      margin-top: -35px;
    }
  }
}
</style>
